import { Pipe, PipeTransform } from '@angular/core';
import { getStudentGrade } from 'src/app/core/utils/grade';

@Pipe({
    name: 'displayGrade',
    pure: true,
    standalone: true
})
export class DisplayGradePipe implements PipeTransform {
  transform = getStudentGrade;
}
